import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=45aac43c&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=js&"
export * from "./SignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=45aac43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aac43c",
  null
  
)

export default component.exports